import React, { useCallback } from 'react';

import ModalFooterButton from 'components/Modal/ModalFooterButton';
import { Handle } from 'components/SocialAccountInfo';
import { Step } from 'components/SteppedModal';
import SwitchAccountMessage from 'components/SwitchAccountMessage';
import useInstagramAuthenticator, {
  UseInstagramAuthenticatorConfig,
} from 'hooks/useInstagramAuthenticator';

export interface UseSwitchAccountStepConfig
  extends Partial<Pick<UseInstagramAuthenticatorConfig, 'onError'>> {
  onSwitchAccount?: () => void;
  onSwitchAccountSuccess?: () => void;
  username?: string;
}

export default function useSwitchAccountStep(
  config: UseSwitchAccountStepConfig = {},
): Step {
  const { onSwitchAccount, onSwitchAccountSuccess, onError, username } = config;

  const { authenticate, authenticating } = useInstagramAuthenticator({
    force: true,
    onAuthSuccess: onSwitchAccountSuccess,
    onError,
  });

  const handleAuthenticate = useCallback((): void => {
    onSwitchAccount();
    authenticate();
  }, [authenticate, onSwitchAccount]);

  return {
    id: 'switch',
    title: 'switch instagram accounts',
    component: (
      <SwitchAccountMessage username={<Handle username={username} />} />
    ),
    renderFooterButtons: ({ cancel, submit }) => [
      <ModalFooterButton {...cancel} key="cancel">
        cancel
      </ModalFooterButton>,
      <ModalFooterButton
        {...submit}
        key="submit"
        disabled={authenticating}
        onClick={handleAuthenticate}
        theme="submit"
      >
        switch accounts
      </ModalFooterButton>,
    ],
  };
}
